import React, { memo } from 'react';
import { motion } from 'framer-motion';
const competitors = [{
  name: 'Enterprise AI Platform',
  price: 450,
  color: 'bg-gray-200',
  text: 'text-gray-500'
}, {
  name: 'Agent Framework Pro',
  price: 299,
  color: 'bg-gray-300',
  text: 'text-gray-600'
}, {
  name: 'Memory API Service',
  price: 150,
  color: 'bg-gray-400',
  text: 'text-gray-700'
}, {
  name: 'GetCozy',
  price: 15,
  color: 'bg-cozy-accent',
  text: 'text-white',
  isHighlight: true
}];
const MAX_PRICE = 500;
export function Pricing() {
  return <section className="py-24 bg-white border-y border-cozy-border" data-id="element-169">
      <div className="max-w-4xl mx-auto px-6" data-id="element-170">
        <div className="text-center mb-16" data-id="element-171">
          <h2 className="font-serif text-4xl md:text-5xl mb-4 text-cozy-text" data-id="element-172">
            100x cheaper than the market.
          </h2>
          <p className="text-cozy-muted text-lg max-w-2xl mx-auto" data-id="element-173">
            By optimizing our vector storage and using intelligent
            context-routing, we've driven the cost of continuous AI memory down
            to the floor.
          </p>
        </div>

        <div className="bg-cozy-bg rounded-2xl p-8 md:p-12 border border-cozy-border shadow-sm" data-id="element-174">
          <h3 className="text-sm font-medium text-cozy-muted uppercase tracking-wider mb-8" data-id="element-175">
            Monthly Cost (100k queries/mo)
          </h3>

          <div className="space-y-6" data-id="element-176">
            {competitors.map((comp, index) => {
            const widthPercentage = Math.max(comp.price / MAX_PRICE * 100, 5); // min 5% for visibility
            return <div key={comp.name} className="flex flex-col md:flex-row md:items-center gap-2 md:gap-4" data-id="element-177">
                  <div className="md:w-48 text-sm font-medium text-cozy-text shrink-0" data-id="element-178">
                    {comp.name}
                  </div>
                  <div className="flex-1 flex items-center gap-3" data-id="element-179">
                    <motion.div initial={{
                  width: 0
                }} whileInView={{
                  width: `${widthPercentage}%`
                }} viewport={{
                  once: true,
                  margin: '-50px'
                }} transition={{
                  duration: 1,
                  delay: index * 0.1,
                  ease: 'easeOut'
                }} className={`h-10 rounded-md flex items-center px-3 ${comp.color} ${comp.isHighlight ? 'shadow-md' : ''}`} data-id="element-180">
                      <span className={`text-sm font-bold ${comp.text}`} data-id="element-181">
                        ${comp.price}
                      </span>
                    </motion.div>
                  </div>
                </div>;
          })}
          </div>

          <div className="mt-10 pt-6 border-t border-cozy-border flex items-start gap-4" data-id="element-182">
            <div className="w-10 h-10 rounded-full bg-cozy-accent/10 flex items-center justify-center shrink-0" data-id="element-183">
              <span className="text-cozy-accent font-serif text-xl italic" data-id="element-184">
                i
              </span>
            </div>
            <p className="text-sm text-cozy-muted leading-relaxed" data-id="element-185">
              Competitor pricing based on publicly available API and platform
              costs as of Q3. GetCozy's pricing includes unlimited capture and
              100k queries per user.
            </p>
          </div>
        </div>
      </div>
    </section>;
}